module.exports = __webpack_public_path__ + "app/modals/edit-beacon-schedule-modal.view.html";